import { tss } from 'tss-react';

export const useStyles = tss.create({
	seasonalityTableRow: {
		transition: 'all 0.2s ease-in-out',
		'&:hover': {
			opacity: 0.8,
			'& td': {
				fontWeight: 'bold',
			},
		},
	},

	seasonalityTableCell: {
		userSelect: 'none',
		whiteSpace: 'nowrap',
		minWidth: '14rem',
	},

	ingredientCard: {
		userSelect: 'none',
		transition: 'all 0.2s ease-in-out',
		'&:hover': {
			fontWeight: 'bold',
			backgroundColor: '#edf6ff',
		},
	},

	explanationDiv: {
		fontStyle: 'italic',
		fontWeight: 'lighetr',
		fontSize: '14px',
		display: 'flex',
		marginBottom: '1rem',
	},

	centeredFlex: {
		marginRight: '1rem',
		display: 'flex',
		alignItems: 'center',
	},
});
